// Rules shared by the two surfaces that collect emergency contacts — the
// onboarding wizard (step 4, N contacts) and the HR profile form (exactly two).
// Keeping them here stops the two drifting apart.

// Last 10 digits, mirroring contactKey() in apps/api/src/lib/emergencyContacts.ts,
// so "+91 98765 43210" and "9876543210" are recognised as the same number.
export const phoneKey = (phone: string) => phone.replace(/\D/g, "").slice(-10);

export const DUPLICATE_PHONE_MESSAGE =
  "Each emergency contact needs a different phone number — if one contact is unreachable, HR has to be able to reach someone else.";

/**
 * Index of the first contact whose phone repeats an earlier one, or -1.
 * A number shorter than 10 digits is still being typed (or blank), so it never
 * counts as a duplicate — the error must not flash up mid-entry.
 */
export function firstDuplicatePhoneIndex(phones: string[]): number {
  const seen = new Set<string>();
  for (let i = 0; i < phones.length; i++) {
    const key = phoneKey(phones[i] ?? "");
    if (key.length < 10) continue;
    if (seen.has(key)) return i;
    seen.add(key);
  }
  return -1;
}

/** Null when the phones are all distinct, otherwise the message to show. */
export const validateEmergencyContactPhones = (phones: string[]): string | null =>
  firstDuplicatePhoneIndex(phones) === -1 ? null : DUPLICATE_PHONE_MESSAGE;
